__turbopack_context__.v({
  "bookDemoLink": "investorLogin-module-scss-module__IXq9cW__bookDemoLink",
  "bookDemoLinkWrp": "investorLogin-module-scss-module__IXq9cW__bookDemoLinkWrp",
  "bottomPattern": "investorLogin-module-scss-module__IXq9cW__bottomPattern",
  "intro": "investorLogin-module-scss-module__IXq9cW__intro",
  "introDescription": "investorLogin-module-scss-module__IXq9cW__introDescription",
  "introTitle": "investorLogin-module-scss-module__IXq9cW__introTitle",
  "link": "investorLogin-module-scss-module__IXq9cW__link",
  "pageWrapper": "investorLogin-module-scss-module__IXq9cW__pageWrapper",
});
